/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

// eslint-disable-next-line import/no-dynamic-require
const { SUPPORTED_LANGUAGES } = require(`../../../env/config.${
	process.env.NODE_ENV === 'production' ? 'prod' : 'local'
}.js`);

const { pathname } = window.location;
const lngFromURL = pathname.split('/')[1];

export interface Language {
	value: string;
	label: string;
}

type LanguageState = {
	availableLanguagesList: string[];
	activeLanguage: string;
};

export const initialState: LanguageState = {
	availableLanguagesList: SUPPORTED_LANGUAGES,
	activeLanguage: SUPPORTED_LANGUAGES.includes(lngFromURL)
		? lngFromURL
		: Cookies.get('userLang') || 'en',
};
const slice = createSlice({
	initialState,
	name: 'language',
	reducers: {
		setLanguage: (state, { payload }: PayloadAction<string>) => {
			state.activeLanguage = payload;
		},
	},
});

export default slice;
